import config, { categoryNames } from "../config";
import { FilterOptionEnum, ServiceEnum, UNCATEGORIZED_SKETCHUP_HELP_AGGREGATION, } from "../models/dataModel";
function getValueFacet(aggregations, fieldName) {
    if (aggregations &&
        aggregations[fieldName] &&
        aggregations[fieldName].buckets &&
        aggregations[fieldName].buckets.length > 0) {
        return [
            {
                field: fieldName,
                type: "value",
                data: aggregations[fieldName].buckets.map((bucket) => ({
                    // Boolean values and date values require using `key_as_string`
                    value: bucket.key_as_string || bucket.key,
                    count: bucket.doc_count,
                })),
            },
        ];
    }
}
/**
 * Converts search aggregations into Search UI value facets without mutating the response.
 * Category values are restricted to configured category names. When categories are requested,
 * uncategorized SketchUp Help documents contribute to the Trimble Help count.
 *
 * @param aggregations Search response aggregations containing buckets and optional SketchUp counts.
 * @param facetNames Fields to include in the returned facets.
 * @returns Facets keyed by field, or undefined when no requested aggregations produce a facet.
 * A category facet can have empty data if all its bucket values are unsupported.
 */
export default function buildStateFacets(aggregations, facetNames) {
    const facets = facetNames.reduce((result, filterName, index, array) => {
        const facet = getValueFacet(aggregations, filterName);
        if (facet && filterName === FilterOptionEnum.CATEGORY) {
            facet[0].data = facet[0].data.filter((option) => categoryNames.some((name) => name === option.value));
        }
        if (facet)
            result[filterName] = facet;
        return result;
    }, {});
    const sketchUpCount = aggregations?.[UNCATEGORIZED_SKETCHUP_HELP_AGGREGATION]?.doc_count;
    if (facetNames.includes(FilterOptionEnum.CATEGORY) && sketchUpCount) {
        const categoryName = config.services[ServiceEnum.TRIMBLE_HELP].categoryName;
        const categoryFacets = facets[FilterOptionEnum.CATEGORY] || [
            {
                field: FilterOptionEnum.CATEGORY,
                type: "value",
                data: [],
            },
        ];
        const helpCategory = categoryFacets[0].data.find((category) => category.value === categoryName);
        if (helpCategory) {
            helpCategory.count = (helpCategory.count || 0) + sketchUpCount;
        }
        else {
            categoryFacets[0].data.push({ value: categoryName, count: sketchUpCount });
        }
        facets[FilterOptionEnum.CATEGORY] = categoryFacets;
    }
    if (Object.keys(facets).length > 0) {
        return facets;
    }
}
